// Application configuration from environment variables

export const config = {
  // Use relative URLs for API calls (same domain as page)
  // This prevents CORS issues when using multiple domains (test.illuminativesolutions.io, etc.)
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',
  userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
  clientId: import.meta.env.VITE_CLIENT_ID || '',
  stageName: import.meta.env.VITE_STAGE_NAME || '',
} as const;

// Helper to get full API endpoint
// When apiBaseUrl is empty, returns relative URL (e.g., "/db/employees")
// This ensures API calls use the same domain as the current page
export const getApiUrl = (path: string): string => {
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  if (config.apiBaseUrl) {
    return `${config.apiBaseUrl}${config.stageName}${cleanPath}`;
  }

  // Relative URL - will use current domain
  return `${config.stageName}${cleanPath}`;
};
